







































































































































































































import { Component } from 'vue-mixin-decorator';
import { Watch } from 'vue-property-decorator';

import { loadStripe } from '@stripe/stripe-js';
import axios from 'axios';

import BaseView from '@/views/BaseView.vue';
import ExamFooter from '@/components/ExamFooter.vue';
import ExamGuide from '@/components/ExamGuide.vue';
import ExamNav from '@/components/ExamNav.vue';
import IndicatorModal from '@/components/IndicatorModal.vue';
import ConfirmModal from '@/components/ConfirmModal.vue';

import { REGISTER_USER_INFO, EXAMINEE_ITEMS } from '@/classification/SessionStorageKey';

import * as JwtUtil from '@/common/JwtUtil';
import * as StringUtil from '@/common/StringUtil';
import * as CartUtil from '@/common/CartUtil';

import RepositoryFactory from '@/repository/RepositoryFactory';

import ExamInfo from '@/models/exam/ExamInfo';
import CartPurchaseParam from '@/models/cart/apiParam/CartPurchaseParam';
import Cart from '@/models/cart/Cart';
import CartItem from '@/models/cart/CartItem';
import * as DesignCode from '@/classification/DesignCode';
import CalcCart from '@/models/cart/CalcCart';

@Component(
  {
    components: {
      'e-footer': ExamFooter,
      'e-guide': ExamGuide,
      'e-nav': ExamNav,
      'e-indicator': IndicatorModal,
      'e-confirm-modal': ConfirmModal,
    },
  },
)
export default class CartConfirm extends BaseView {
  private examInfo = new ExamInfo();

  private jwt = null;

  private CartRepository = RepositoryFactory.get().cart;

  private isIndicatorDisplay = false;

  private isEntryBadCondition = false;

  private msgPurchaseError = '';

  private cartCode = '';

  private cart = new Cart();

  private totalAmount = 0;

  private cartItems: CartItem[] = [];

  private serialCodes = new Array<string>();

  private inRecalc = false;

  private tokushoho = '';

  $refs!: {
    examNav: ExamNav;
  }

  private async created() {
    this.isIndicatorDisplay = true;
    this.jwt = JwtUtil.getJwtInfo();

    this.serialCodes.push('');

    await this.getExamInfo();
    await this.getCartInfo();

    this.isIndicatorDisplay = false;
  }

  private async mounted() {
    await this.getTokushoho();
    this.initialStaticScript();
  }

  /**
   * 検定情報を取得する
   */
  private async getExamInfo() {
    try {
      const ExamRepository = RepositoryFactory.get().exam;
      await ExamRepository.getExam().then((response) => {
        this.examInfo.examTitle = response.data.exam_title;
        this.examInfo.useNameFlg = response.data.use_name_flg;
        this.examInfo.useNameKanaFlg = response.data.use_name_kana_flg;
        this.examInfo.useGenderFlg = response.data.use_gender_flg;
        this.examInfo.useAddressFlg = response.data.use_address_flg;
        this.examInfo.useMailAnnounceFlg = response.data.use_mail_announce_flg;
        this.examInfo.usePaymentsKonbiniFlg = response.data.use_payments_konbni_flg;
        this.examInfo.usePaymentsSerialFlg = response.data.use_payments_serial_flg;
        this.examInfo.konbiniExpireDays = response.data.konbini_expire_days;
      }).catch(() => {
        this.redirectToTOP();
      });
    } catch (e) {
      this.redirectToTOP();
    }
  }

  /**
   * 買い物カゴ情報を取得する
   */
  private async getCartInfo() {
    const cartCode = sessionStorage.getItem(CartUtil.SESSION_CART_CODE_KEY);

    if (cartCode === null || StringUtil.isEmpty(cartCode)) {
      return;
    }
    await CartUtil.getCart(this.CartRepository, cartCode).then((v) => {
      if (v === undefined) {
        this.cart = new Cart();
        sessionStorage.removeItem(CartUtil.SESSION_CART_CODE_KEY);
        return;
      }
      this.cart = v;
    }).catch(() => {
      this.cart = new Cart();
      sessionStorage.removeItem(CartUtil.SESSION_CART_CODE_KEY);
    });
  }

  /**
   * 最終確認への遷移
   */
  private async purchaseConfirm() {
    this.isIndicatorDisplay = true;
    this.isEntryBadCondition = false;
    this.msgPurchaseError = '';
    if (this.jwt === null) {
      sessionStorage.setItem(JwtUtil.SESSION_RETURN_PATH_KEY, this.paths.PURCHASE_CART_CONFIRM);
      this.$router.replace({ path: this.paths.LOGIN });
    }

    // SessionStorageの登録情報を削除 // 会員登録とは別手続きになったので無用だが念の為
    sessionStorage.removeItem(REGISTER_USER_INFO);
    sessionStorage.removeItem(EXAMINEE_ITEMS);

    if (!this.cart.canBuy) {
      this.$router.replace({ path: this.paths.PURCHASE_CANNOT_PURCHASE });
      return;
    }
    await this.purchaseCart();
    this.isIndicatorDisplay = false;
  }

  private async applySerialCode() {
    this.isIndicatorDisplay = true;
    const param = new CartPurchaseParam();
    param.cartCode = this.cartCode;
    param.serialCodes = this.serialCodes;
    await CartUtil.calcCart(this.CartRepository, param).then((calcResult) => {
      if (calcResult === undefined) {
        this.isEntryBadCondition = true;
        this.msgPurchaseError = '計算に失敗しました。';
        return;
      }
      this.setCalcResult(calcResult);
    }).catch(() => {
      this.isEntryBadCondition = true;
      this.msgPurchaseError = '計算に失敗しました。';
    }).finally(() => {
      this.isIndicatorDisplay = false;
    });
  }

  /** 購入手続き */
  private async purchaseCart() {
    this.isIndicatorDisplay = true;
    try {
      let sessionId = null;
      const param = new CartPurchaseParam();
      param.cartCode = this.cartCode;
      param.serialCodes = this.serialCodes;
      await CartUtil.purchaseCart(this.CartRepository, param).then((response: any) => {
        sessionId = response.data.stripe_session_id;
      }).catch((err) => {
        if (err.response.status === 400) {
          this.isEntryBadCondition = true;
          this.msgPurchaseError = String(err.response.data.error).replace(/\r?\n/g, '<br/>');
          if (this.msgPurchaseError === 'undefined') {
            this.msgPurchaseError = '購入手続きに失敗しました。';
          }
        } else {
          this.isEntryBadCondition = true;
          this.msgPurchaseError = '購入手続きに失敗しました。';
        }
      });

      if (this.isEntryBadCondition) return;

      if (sessionId === null || StringUtil.isEmpty(sessionId)) {
        this.$router.replace({ path: this.paths.MY_PAGE });
      } else {
        sessionStorage.removeItem(CartUtil.SESSION_CART_CODE_KEY);
        // セッションIDを使ってCheckout（Stripeの支払い画面）にリダイレクト
        const stripe = await loadStripe(String(process.env.VUE_APP_STRIPE_SITE_KEY));
        if (stripe !== null) {
          stripe.redirectToCheckout({ sessionId });
        }
      }
    } catch (_) {
      JwtUtil.deleteJwt();
    } finally {
      this.isIndicatorDisplay = false;
    }
  }

  /**
   * CSSとJSの読み込み
   */
  private initialStaticScript() {
    const CommonCss = document.createElement('link');
    CommonCss.rel = 'stylesheet';
    CommonCss.href = '/css/common.css';
    this.$el.appendChild(CommonCss);

    const AccountCommonCss = document.createElement('link');
    AccountCommonCss.rel = 'stylesheet';
    AccountCommonCss.href = '/account/css/common.css';
    this.$el.appendChild(AccountCommonCss);

    const ConfirmCss = document.createElement('link');
    ConfirmCss.rel = 'stylesheet';
    ConfirmCss.href = '/css/purchase/confirm.css';
    this.$el.appendChild(ConfirmCss);

    this.getExamConfigCss().then((cssElement: HTMLLinkElement) => {
      this.$el.appendChild(cssElement);
    });

    const CommonJs = document.createElement('script');
    CommonJs.src = '/js/common.js';
    this.$el.appendChild(CommonJs);
  }

  /**
   * TOP画面に遷移
   */
  private redirectToTOP() {
    this.$router.replace(this.paths.TOP);
  }

  addSerialCodeBox() {
    this.serialCodes.push('');
  }

  async deleteCartItem(index: number) {
    this.isIndicatorDisplay = true;
    const cartItem = this.cartItems[index];
    try {
      await CartUtil.removeCartItem(this.CartRepository, this.cartCode, cartItem.cartItemId);
      this.cartItems.splice(index, 1);
      await this.getCartInfo();
      await this.$refs.examNav.refreshCart();
    } catch {
      this.msgPurchaseError = '削除に失敗しました';
    }
    this.isIndicatorDisplay = false;
  }

  // eslint-disable-next-line class-methods-use-this
  formatPrice(fee: number): string {
    return StringUtil.separateNumber(fee);
  }

  async changeQuantity(cartItemId: number, newQuantity: number) {
    const cartItem = this.cartItems.find((v) => v.cartItemId === cartItemId);
    if (cartItem === null || cartItem === undefined) {
      return;
    }
    cartItem.quantity = newQuantity;
    this.inRecalc = true;

    await CartUtil.changeQuantity(this.CartRepository, this.cartCode, cartItemId, newQuantity);
    await this.getCartInfo();
    await this.$refs.examNav.refreshCart();

    this.inRecalc = false;
  }

  transitionCartItemDetail(cartItem: CartItem) {
    if (cartItem.constructor.name === 'CartItemGoods') {
      this.$router.replace(`${this.paths.GOODS_DETAIL}?goods_code=${StringUtil.encodeToBase64Url(cartItem.code)}`);
    } else {
      this.$router.replace(`${this.paths.KENTEI_DETAIL}?rank=${StringUtil.encodeToBase64Url(cartItem.code)}`);
    }
  }

  private async getTokushoho() {
    const ExamRepository = RepositoryFactory.get().exam;
    await ExamRepository.getExamDesignResource(DesignCode.INQUIRY_URL).then((response) => {
      if (response.status === 200 && response.data !== undefined) {
        const inquiryUrl = String(response.data.display_text);
        this.getTokushoMain(inquiryUrl);
      }
    });
  }

  async getTokushoMain(inquiryUrl: string) {
    const ExamRepository = RepositoryFactory.get().exam;
    ExamRepository.getExamTextResource('tokushoho').then((response) => {
      if (response.status !== 200 || response.data === undefined) {
        this.getTokushoFromStatic(inquiryUrl);
        return;
      }
      const tokushoHtml = response.data.text;
      if (typeof tokushoHtml === 'string') {
        this.tokushoho = tokushoHtml.replace('{{INQUIRY_URL}}', inquiryUrl);
      } else {
        this.getTokushoFromStatic(inquiryUrl);
      }
    });
  }

  async getTokushoFromStatic(inquiryUrl: string) {
    let baseUrl = process.env.VUE_APP_BASE_URL;
    if (baseUrl === 'http://localhost:8080') {
      baseUrl = 'http://localhost:8030';
    }

    const main = await axios.get(`${baseUrl}/static/tokushoho_main.html`)
      .then((response: any) => response.data);
    if (typeof main === 'string') {
      this.tokushoho = main.replace('{{INQUIRY_URL}}', inquiryUrl);
    }
  }

  setCalcResult(calcResult: CalcCart) {
    this.totalAmount = calcResult.totalAmount;
    calcResult.calcItems.forEach((v) => {
      const { cartItemId } = v;
      const cartItem = this.cartItems.find((i) => i.cartItemId === cartItemId);
      if (cartItem === undefined) {
        return;
      }
      cartItem.totalFee = v.totalAmount;
      cartItem.serialCodes = v.serialCodes;
    });
  }

  @Watch('cart')
  changeCart() {
    this.cartCode = this.cart.cartCode;
    this.cartItems = this.cart.cartItems;
    this.totalAmount = this.cart.totalFee;
  }
}
